
import { createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import AsyncStorage from '@react-native-async-storage/async-storage'
import Reducer from './Reducer'

const persistConfig = {
  key: 'root',
  storage: AsyncStorage,
  blacklist: ['date', 'modal_journey', 'modal_trip_info']
}

const persistedReducer = persistReducer(persistConfig, Reducer)

export default () => {
  let store = createStore(persistedReducer)
  let persistor = persistStore(store)
  return { store, persistor }
}